
export const ROUTES = {
  DASHBOARD: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgotPassword',
  CREATE_NEW_PASSWORD: '/createPassword',
  CHANGE_PASSWORD: '/changePassword',
  USER_MANAGEMENT: '/userManagement',
  BRAND_MANAGEMENT: '/brands',
  CAMPAIGN_MANAGEMENT: '/campaign-management',
  ADMIN_USERS: '/adminUsers',
  ROLES_AND_RIGHTS: '/roles',
  SUBSCRIPTION_MGT: '/subscriptions',
  AUDIT_TRAILS: '/audit-trails',
  ACTIVE_DEVICES: '/active-devices',
  USER_DELETED: "/user/deleted",
  USER_DETAILS: "/userManagement/details/",
  VERIFY_NEW_USER_DETAILS: 'details',
  ///userManagement/details/
  EDIT: '/edit',
  ADD: '/create',
  CREATE_INFLUENCER: '/createInfluencer',
  EDIT_INFLUENCER: '/editInfluencer',
  SIGN_UP: '/signup',
  VIEW: '/view',
  CREATE_CAMPAIGN: "/createCampaign",
  MY_CAMPAIGN: "/myCampaign",
  EDIT_CAMPAIGN: "/editCampaign",
  TEST: '/test',
  COMPANY_ADD: '/company/add',
  COMPANY_EDITS: '/company/edit',
  CAMPAIGN_STEP1: "campaign/type",
  CAMPAIGN_STEP2: "campaign/sub-type",
  CAMPAIGN_STEP3: "campaign/info",
  CAMPAIGN_STEP4: "campaign/budget-target",
  CAMPAIGN_STEP5: "campaign/dates",
  CAMPAIGN_STEP6: "campaign/profile-screener",
  CAMPAIGN_STEP7: "campaign/review",
  CAMPAIGN_REVIEW: "campaign/submit-review",
  CAMPAIGNS: "campaigns",
  CAMPAIGNS_DETAILS: "campaign/details",
  SEARCH_INFLUENCER: "campaign/search-influencer",
  BRANDS_FOR_COMPANY: '/company-brands',
  ADD_BRANDS_FOR_COMPANY: '/company-brands/add',
  COMPANY_EDIT: '/company-brands/add',
  MY_CAMPAIGNS: "my-campaigns",
  DISCOVER_INFLUNCERS: "discover-influencers",
  MY_CAMPAIGN_INFLUENCER: "my-campaigns/influencer",
  MY_CAMPAIGN_APPROVED_INFLUENCER: "my-campaigns/approved-influencer",
  NEGOTIATED_INFLUENCER: "my-campaigns/negotiated-influencers",
  COMPANY_SIGNUP: 'company-signup',
  USER_MANAGEMENT_DETAILS: '/userManagement/details',
  COMPANIES: "companies",
  SEARCH_INFLUENCER_BY_COMPANY: "search-Influencers",
  COMPANY_DETAILS: "company/details",
  CAMPAIGN_DETAILS: "campaign/details",
  COMING_SOON: "coming-soon",
  RESET_PASSWORD: "reset-password",
  COMPANY_PROFILE_EDIT: "company/profile",
  PRIVACY_POLICY: "privacy-policy",
  INFLUENCER_LISTING: "discover-influencers/listing",
  PARTIAL_CAMPAIGN_DETAILS: "campaign/partial/details",
  SEND_MORE_INFLUENCER: "campaign/send-more-influencer",
  VERIFY_OTP: "verify",
  CREATOR_MANAGEMENT: "creator-management",
  CREATOR_CONTENT_LIST: "creator-content",
  USER_BRANDS_LIST: "user-brands",
  ADD_SUBSCRIPTION: '/subscription/create',
  EDIT_SUBSCRIPTION: '/subscription/edit',
  DETAILS_SUBSCRIPTION: '/subscription/details',


  SUBSCRIPTION_FOR_COMPANY: '/company/subscription',
  ACTIVE_SUBSCRIPTION: '/subscription/active',
  ACTIVE_SUBSCRIPTION_DETAILS: '/subscription/active/details',


  SUBSCRIPTION_HISTORY: '/subscription/history',

  COMPANY_USERS: '/company/users',
  COMPANY_USER_ADD: '/company/user/add',
  COMPANY_USER_EDIT: '/company/user/edit',

  WALLET: "wallet",
  CAMPAIGN_WALLET: "wallet/campaign",

  GROUP_NOTIFICATION: "notification/group",
  ADD_GROUP_NOTIFICATION: "notification/group/add",
  EDIT_GROUP_NOTIFICATION: "notification/group",
  GROUP_NOTIFICATION_DETAILS: "notification/group/details",
  ADD_NOTIFICATION: "notification/add",
  EDIT_NOTIFICATION: "notification",
  NOTIFICATION_HISTORY: "notification/history",
  NOTIFICATION_EDITOR: "notification/editor",
  COMMUNITY_POSTS: "notification/communityposts",
  COMMUNITY_POSTS_ADD: "notification/communityposts/add",
  COMMUNITY_POSTS_EDIT: "notification/communityposts/edit",
  PAYMENT_STATUS: "payment/status",
  POST_CAMPAIGN_ANALYSIS: "campaign/analysis",
  KYC: "kyc",
  POST_CAMPAIGN: "campaign/postcampaign",
  privacy: "privacy-and-policy",
  terms: "terms-and-conditions",
  LIST: "list",
  WISHLIST_ADD_INFLUENCER_LISTING: "list/listing",
  WISHLIST_INFLUENCER_LISTING: "list/influncerslisting",
  INFLUENCER_SUBSCRIPTION_LIST: '/influencer-subscriptions',
  ADD_INFLUENCER_SUBSCRIPTION: '/influencer-subscriptions/create',
  DETAILS_INFLUENCER_SUBSCRIPTION: '/influencer-subscriptions/details',
  CAMPAIGN_BY_INFLUENCER_LIST: '/campaign-by-influencer/list',
  CAMPAIGN_BY_INFLUENCER_DETAILS: '/campaign-by-influencer/details',
  CAMPAIGN_BY_INFLUENCER_DETAILS_ADMIN: '/campaign-by-influencer/details-admin',
  APP_VERSIONS_LIST: '/app-versions',
  APP_VERSIONS_ADD: '/app-versions/add',
  APP_VERSIONS_EDIT: '/app-versions/edit',
  ALL_BILLS: '/all-bills',
  INFLUENCER_SUBSCRIPTION_TYPE_LIST: '/7dK92mXvPq5n',
  INFLUENCER_SUBSCRIPTION_TYPE_ADD: '/7dK92mXvPq5n/create',

  INFLUENCER_SUBSCRIPTION_TYPE_EDIT: '/7dK92mXvPq5n/edit',
  CHECK_EMAIL: '/check-email',
  VERIFY_EMAIL: '/verify-email',
  REQUESTED_INFLYX_COINS: '/requested-inflyx-coins',
  CREDIT_LIST: '/credit-list',
  DELINK_REQUESTS: '/delink-requests',
  WITHDRAWAL_REQUESTS: '/withdrawal-requests',
  INFLUENCER_INSIGHTS: '/influencer-insights',
  INFLUENCER_INSIGHT_DETAILS: '/influencer-insights/details',
  ULTIMATE_DISCOVER: 'discover',
  ULTIMATE_DISCOVER_DETAILS: 'discover/details',

  // Security & Logs (superadmin). A shared `/security` first segment lets the
  // sidebar parent highlight on a single isActive entry.
  SECURITY_API_LOGS: '/security/api-logs',
  SECURITY_RATE_LIMITS: '/security/rate-limits',
  SECURITY_BLOCKED: '/security/blocked',
  SECURITY_SESSIONS: '/security/sessions',
}
